import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal__close"
}

import { onBeforeUnmount, onMounted, watch, ref, computed } from 'vue'

// Use
import { useScrollLock } from '@vueuse/core'
import useThemeClassName from '@/hooks/useThemeClassName'

// Components
import Button from '@/components/ui/Button'

// Data
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    theme: {},
    closeByBg: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    closeWhileLoading: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const body = ref<HTMLElement | null>(document.body)
const isLocked = useScrollLock(body)

// Types
const props = __props

const emit = __emit

// Computed
const themeClassName = computed(() => useThemeClassName('modal', props.theme))

// Methods
function close(): void {
  if (props.loading && !props.closeWhileLoading) {
    return
  }
  emit('close')
}

function doCloseByBg(): void {
  if (props.closeByBg) {
    close()
  }
}

onMounted(() => {
  isLocked.value = true
})

onBeforeUnmount(() => {
  isLocked.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", [themeClassName.value]]),
    onClick: doCloseByBg
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal__content", {'modal__content_loading': _ctx.loading}]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_ctx.showCloseButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Button), {
              theme: "icon-padding",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draw_svg, {
                  name: "close",
                  width: "10",
                  height: "10"
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})